import { postRequest } from '../../httpClient';
import type { IUploadMediaResponse } from './upload-media-response';
import { uploadMediaResponseSchema } from './upload-media-response';

export async function uploadMediaApi(file: File): Promise<IUploadMediaResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const result = await postRequest<IUploadMediaResponse>({
    path: '/sys/media/upload',
    body: formData,
    schema: uploadMediaResponseSchema,
  });
  return result.data;
}
